/**
 * Bind js handlers to js-swipe-image div to cause swipes within that div to
 * trigger clicks on js-right or js-left depending on swipe direction.
 */

export default class SwipeCarouselNavigation {
  constructor() {
    this.bindHandlers();
  }

  bindHandlers() {
    $('.js-swipe-image').hammer();

    N2.handle('swipeleft', '.js-swipe-image', (evt) => {
      $('.js-right').click();
    });

    N2.handle('swiperight', '.js-swipe-image', (evt) => {
      $('.js-left').click();
    });
  }
}
